/* eslint-disable no-sequences */
/* eslint-disable no-plusplus */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getCookies } from "../hooks/useCookies";
import { SERVER_BASE_URL } from "./apiConstants";
import envValues from "../enviornment";

function toFormData(o, formData) {
  // eslint-disable-next-line no-sequences
  const value = Object.entries(o).reduce(
    (d, e) => (d.append(...e), d),
    formData
  );
  return value;
}

export const Entry = createAsyncThunk("api/create", async (data) => {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${getCookies("Token")}`,
  };
  const formData = new FormData();
  const { actionUrl } = data;
  const { actionMethod } = data;
  console.log(actionUrl, "gfd");
  console.log(envValues, "envValues");
  console.log(data, "SERVER BASE URL");
  console.log("console ends in entrySlice.js");
  delete data.actionUrl;
  delete data.actionMethod;

  const filesToAppend =
    Object.keys(data).length && data.apiData.files ? data.apiData.files : [];
  if (filesToAppend.length) {
    for (let i = 0; i < filesToAppend.length; i++) {
      formData.append("files", filesToAppend[i]);
    }
    delete data.apiData.files;
    headers["Content-Type"] = "multipart/form-data";
  }
  switch (actionMethod) {
    case "post":
      return axios
        .post(
          `${SERVER_BASE_URL}/${actionUrl}`,
          filesToAppend.length
            ? toFormData(data.apiData, formData)
            : data.apiData,
          { headers },
          {
            headers,
          }
        )
        .then((response) => {
          console.log(response); // Log the response
          return response.data; // Return the response data
        })
        .catch((e) => e.response.data);
    case "patch":
      return axios
        .patch(
          `${SERVER_BASE_URL}/${actionUrl}`,
          filesToAppend.length
            ? toFormData(data.apiData, formData)
            : data.apiData,
          {
            headers,
          }
        )
        .then((response) => response.data)
        .catch((e) => e.response.data);

    case "delete":
      return axios
        .delete(`${SERVER_BASE_URL}/${actionUrl}`, { headers })
        .then((response) => {
          return response.data; // Return the response data
        })
        .catch((e) => e.response.data);
    default:
      return axios
        .get(`${SERVER_BASE_URL}/${actionUrl}`, { headers })
        .then((response) => response.data)
        .catch((e) => e.response.data);
  }
});

const EntrySlice = createSlice({
  name: "api",
  initialState: {
    loading: false,
    Data: {},
    error: "",
  },
  extraReducers: {
    [Entry.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [Entry.fulfilled]: (state, action) => {
      state.loading = false;
      state.Data = action.payload;
    },
    [Entry.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default EntrySlice.reducer;
